import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { api_paths } from "../config/api.paths";
import API from "../config/axios";
import { SET_USER } from "../redux/user";
import EditProfileModal from "../components/member/EditProfileModal";
import editIcon from "../assets/images/icons/edit.svg";
import EditMobileModal from "../components/member/EditMobileModal";
import OtpModal from "../components/auth/OtpModal";
import { toastErrorMessage, toastSuccessMessage } from "../utils/utils";

export default function ProfilePage() {
  const dispatch = useDispatch();

  const reduxUser = useSelector((state) => state.USER_DATA.user);
  const [user, setUser] = useState(reduxUser);
  const [plan, setPlan] = useState(null);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showUpdateMobileModal, setShowUpdateMobileModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpId, setOtpId] = useState(null);

  // 🔥 FETCH USER FROM API WHEN PAGE DIRECTLY OPENED
  const fetchUser = async () => {
    try {
      const response = await API.get(api_paths.member.GET_USER);
      if (response.status === 200) {
        const data = response.data?.payload?.result;
        setUser(data);
        dispatch(SET_USER(data));
      }
    } catch (error) {
      console.log("Error fetching user:", error);
    }
  };

  const fetchPlanAmount = async () => {
    try {
      const response = await API.get(api_paths.member.membership.GET_PLAN);

      if (response.status === 200) {
        const amount = response.data?.payload?.result || 0;

        if (Array.isArray(amount) && amount.length > 0) {
          setPlan(amount[0]); // store first plan object
        }
      }
    } catch (error) {
      console.error("Error fetching plan amount:", error);
    }
  };

  useEffect(() => {
    if (!reduxUser || !reduxUser._id) {
      fetchUser();
    }
    fetchPlanAmount();
    // eslint-disable-next-line
  }, []);

  const handleVerifyOtp = async (otp, otp_id) => {
    try {
      const response = await API.post(api_paths.member.VERIFY_OTP, {
        otp,
        otp_id,
      });

      if (response.status === 201) {
        toastSuccessMessage("Mobile number updated successfully");

        setShowOtpModal(false);
        console.log(showOtpModal, "showOtpModal");
        await fetchUser();
      }
    } catch (error) {
      toastErrorMessage(
        error.response?.data?.message || "Failed to verify OTP"
      );
    }
  };

  const handleResendOtp = async (otp_id) => {
    try {
      const response = await API.post(api_paths.member.RESEND_OTP, {
        otp_id,
      });

      if (response.status === 200) {
        toastSuccessMessage("OTP resent successfully");
      }
    } catch (error) {
      toastErrorMessage(
        error.response?.data?.message || "Failed to resend OTP"
      );
    }
  };

  if (!user) return <div className="text-center">Loading...</div>;

  return (
    <div className="container py-5">
      <h2 className="mb-4 fw-bold profile-info-heading">
        Welcome, {user.first_name} {user.last_name}!
      </h2>

      <div className="row">
        {/* LEFT SIDE – PROFILE INFO */}
        <div className="col-lg-8 mb-4">
          <Card className="p-4 profile-info-card">
            <h5 className="fw-semibold mb-4">Profile Information</h5>

            <div className="mb-3 field-line">
              <label className="form-label">Name</label>
              <div className="fw-semibold">
                {user.first_name} {user.last_name}
              </div>
            </div>

            <div className="mb-3 field-line">
              <label className="form-label">Email</label>
              <div className="fw-semibold">{user.email}</div>
            </div>

            <div className="mb-3 field-line position-relative">
              <label className="form-label mb-1">Mobile</label>

              <div className="fw-semibold pe-4">
                {user.country_code} {user.phone}
              </div>

              <img
                src={editIcon}
                alt="edit"
                className="edit-icon"
                onClick={() => {
                  console.log("icon clicked");
                  setShowUpdateMobileModal(true);
                }}
              />
            </div>

            <div className="mb-3 field-line">
              <label className="form-label">Date Of Birth</label>
              <div className="fw-semibold">
                {user.date_of_birth
                  ? new Date(user.date_of_birth).toLocaleDateString()
                  : "—"}
              </div>
            </div>

            <div className="mb-3 field-line">
              <label className="form-label">Gender</label>
              <div className="fw-semibold">
                {user.gender?.charAt(0).toUpperCase() + user.gender?.slice(1)}
              </div>
            </div>
            <div className="mb-3">
              <Button
                className="btn-orange-lg"
                onClick={() => setShowEditProfileModal(true)}
              >
                Edit Profile
              </Button>
            </div>
          </Card>
        </div>

        {/* RIGHT SIDE – MEMBERSHIP SECTION */}
        <div className="col-lg-4">
          {/* CASE 1: ACTIVE MEMBERSHIP */}
          {new Date(user.membership_expiry_date) > new Date() &&
            user.membership_id && (
              <Card
                className="shadow-sm border-0 overflow-hidden"
                style={{ borderRadius: 12 }}
              >
                {/* Top Header */}
                <div
                  style={{
                    background: "#E8A033",
                    padding: "12px 0",
                    color: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  Membership
                </div>

                {/* Body Section */}
                <div
                  style={{
                    background: "#FFF9F0",
                    padding: "16px",
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ fontWeight: 500 }}>
                    Expiry Date:{" "}
                    {new Date(user.membership_expiry_date).toLocaleDateString()}
                  </span>
                </div>
              </Card>
            )}

          {/* CASE 2: EXPIRED MEMBERSHIP */}
          {new Date(user.membership_expiry_date) < new Date() &&
            user.membership_id && (
              <Card
                className="shadow-sm border-0 overflow-hidden"
                style={{ borderRadius: 12 }}
              >
                <div
                  style={{
                    background: "#E8A033",
                    padding: "12px 0",
                    color: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  Membership Expired
                </div>

                <div
                  style={{
                    background: "#FFF9F0",
                    padding: "16px",
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ fontWeight: 500 }}>
                    Expiry Date:{" "}
                    {new Date(user.membership_expiry_date).toLocaleDateString()}
                  </span>
                </div>

                <Button className="btn-orange mt-3 px-24 mb-3">
                  Renew Membership
                </Button>
              </Card>
            )}

          {/* CASE 3: NO MEMBERSHIP */}
          {!user.membership_id && (
            <Card className="fees-card p-4">
              <h5 className="fw-semibold text-center">Membership Fees</h5>

              {/* Plan Price + Discount */}
              <div className="mt-3 fees-content-1">
                <div className="d-flex justify-content-between ">
                  <span className="d-block">{plan?.plan_name}</span>
                  <strong className="d-block">${plan?.amount}</strong>
                </div>
                {plan?.discount_amount && (
                  <div className="d-flex justify-content-between mt-2">
                    <span className="d-block">Discount</span>
                    <strong className="d-block text-success">
                      -${plan?.discount_amount}
                    </strong>
                  </div>
                )}
              </div>

              <hr />

              {/* Final Total */}
              <div className="d-flex justify-content-between total-amount">
                <strong>Total Amount</strong>
                {plan && <strong>${plan.amount - plan.discount_amount}</strong>}
              </div>

              <Button className="btn-orange w-100 mt-3">Process to Pay</Button>
            </Card>
          )}
        </div>
      </div>

      <EditProfileModal
        show={showEditProfileModal}
        onHide={() => setShowEditProfileModal(false)}
        editData={user} // pass current logged in user data
        refreshList={fetchUser} // reload profile after update
      />

      <EditMobileModal
        show={showUpdateMobileModal}
        onHide={() => setShowUpdateMobileModal(false)}
        editData={user} // pass current logged in user data
        refreshList={fetchUser} // reload profile after update
        onOtpOpen={(id) => {
          setOtpId(id); // save otp id (may be null)
          setShowOtpModal(true); // open otp modal
        }}
      />

      <OtpModal
        isOpen={showOtpModal}
        onClose={() => setShowOtpModal(false)}
        onVerify={handleVerifyOtp}
        onResend={handleResendOtp}
        otp_id={otpId} // or API returned OTP id
      />
    </div>
  );
}
